import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../../SpecialtyPersonalStyles.module.scss"
import metadata from './OtherComponent.metadata.json5';

function OtherComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, propertyPathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('OtherComponent');

    const modelVM = _.get(submissionVM, pathUpdated);
    const propertyModelVM = _.get(submissionVM, propertyPathUpdated);


    modelVM.value.isValidationReq = _.get(propertyModelVM, 'occFie.value.code') === 'RenCon' || _.get(propertyModelVM, 'occFie.value.code') === 'SeaConwitShoTerRen';

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        doyoureqTheandAttTheEndFie: {
            visible: _.get(propertyModelVM, 'occFie.value.code') === 'RenCon' || _.get(propertyModelVM, 'occFie.value.code') === 'SeaConwitShoTerRen'
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OtherComponent.propTypes = wizardProps;
export default withRouter(OtherComponent);
